import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.public.user-accounts.add', {
        url: '/add/:type',
        params: { copyAccount: null},
        views: {
            '@user': 'publicUserAccountsAdd',
        },
        resolve: {
            copyAccount,
            type,
        },
    });
}

/** @ngInject */
function copyAccount($stateParams) {
    return $stateParams.copyAccount;
}

/** @ngInject */
function type($stateParams) {
    return $stateParams.type;
}




// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/add/add-public-user-account.state.js